var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-breadcrumbs',{staticClass:"px-0"}),_c('v-row',{staticClass:"mt-10",staticStyle:{"min-height":"50vh"}},[_c('v-col',[_c('span',{staticClass:"header bold text-tcdc-green text-uppercase"}),_c('VisitLayout')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }